<template>
    <div>
        <CurrentPlanCard
            v-for="type of types"
            :key="type"
            :type="type"
            :plan-action="currentPlansHash[type]"
            :plan="currentPlansHash[type] && plansHash[currentPlansHash[type].planId]"
            :features="localFeatures"
            @show-plans="showPlans(type)"
            :trial-plan="trialInfo.remainingDays > 0"
        />
    </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import CurrentPlanCard from "../../../../../components/billing/CurrentPlanCard.vue";
import _ from "lodash";
import moment from "moment";

export default {
    name: "CurrentPlans",
    components: {
        CurrentPlanCard,
    },
    props: {
        siteId: {
            type: String,
            default: null,
        },
        sitePlans: {
            type: Array,
            default: () => [],
        },
        siteCurrentPlans: {
            type: Array,
            default: () => [],
        },
    },
    data: () => {
        return {
            localFeatures: [],
            plansHash: {},
            currentPlansHash: {},
            types: [],
        };
    },
    mounted() {
        this.initData(this.siteId);
    },
    methods: {
        ...mapActions({
            subscribePlan: "site/subscribePlan",
            unsubscribePlan: "site/unsubscribePlan",
            extraSubscription: "site/extraSubscription",
            getSiteFeatures: "site/getSiteFeatures",
        }),
        async initData(siteId) {
            let features = _.cloneDeep(this.features);
            let plans = _.cloneDeep(this.plans);
            let currentPlans = _.cloneDeep(this.currentPlans);
            if (siteId) {
                features = await this.getSiteFeatures(this.siteId);
                plans = this.sitePlans;
                currentPlans = this.siteCurrentPlans;
            }
            this.localFeatures = features;
            this.types = plans.reduce(
                (a, b) => {
                    if (["feature"].includes(b.type)) return a;
                    const type = b.dynamicType || b.type;
                    if (!a.includes(type)) a = [...a, type];
                    return a;
                },
                [
                    "supsis",
                    "chatbot",
                    "automation",
                    "customer-tables",
                    "mail",
                    "tasks",
                    "form",
                    "whatsapp",
                    "whatsapp-business",
                    "instagram",
                    "messenger",
                    "meta-lead",
                    "trendyol",
                    "webphone",
                ]
            );
            this.currentPlansHash = currentPlans.reduce((acc, plan) => {
                acc[plan.planType] = plan;
                return acc;
            }, {});
            this.plansHash = plans.reduce((acc, plan) => {
                acc[plan._id] = plan;
                return acc;
            }, {});
        },
        showPlans(type) {
            this.$emit("show", type);
        },
    },
    computed: {
        ...mapState({
            features: (state) => state.site.features,
            plans: (state) =>
                state.site.plans
                    .filter((plan) => plan.type !== "feature")
                    .filter((plan) => plan.type !== "extra-package")
                    .filter((plan) => !plan.isDeleted),
            currentPlans: (state) => state.site.currentPlans,
            trialInfo: (state) => {
                const site = state.site.site;
                if (site) {
                    const { createdAt } = site;
                    const diff = Math.ceil(moment().diff(moment(createdAt), "days", true));
                    const tookDays = Math.max(diff, 0);
                    const isTrial = tookDays <= _.get(state.setting.settings, "plan.trialDays");
                    return {
                        trial: isTrial,
                        remainingDays: isTrial ? _.get(state.setting.settings, "plan.trialDays") - tookDays : 0,
                    };
                } else {
                    return { trial: false, remainingDays: 0 };
                }
            },
        }),
    },
    watch: {
        plans: {
            handler() {
                this.initData();
            },
            deep: true,
        },
        currentPlans: {
            handler() {
                this.initData();
            },
            deep: true,
        },
        features: {
            handler() {
                this.initData();
            },
            deep: true,
        },
        sitePlans: {
            handler() {
                this.initData(this.siteId);
            },
            deep: true,
        },
        siteCurrentPlans: {
            handler() {
                this.initData(this.siteId);
            },
            deep: true,
        },
    },
};
</script>
